// extracted by mini-css-extract-plugin
export default {"title":"edit-view-column_title__39okd","content":"edit-view-column_content__EdRp1","submit":"edit-view-column_submit__tM1Zn","item":"edit-view-column_item__HVNGu"};